<template>
  <div class="tab_block">
    <Tab @click="clickLogin">Login</Tab>
    <Tab class="white" @click="clickRegister"><img src="/img/icons/new_save.png"><span>Member<br>Registration</span></Tab>
  </div>
</template>

<script>
import Tab from '@/components/atoms/Tab.vue';

export default {
  components: {
    Tab,
  },

  methods: {
    clickLogin() {
      this.$emit('clickLogin');
    },
    clickRegister() {
      this.$emit('clickRegister');
    },
  },
};
</script>

<style lang="scss" scoped>
.tab_block {
  display: flex;
  justify-content: space-between;
  max-width: 800px;
  margin: 0 auto;
  margin-bottom: -25px;
  @media screen and  (max-width: $tabletWidth) {
    width: 96%;
  }
}
</style>
